/**
 * tdesign v0.21.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { defineComponent, createVNode } from 'vue';
import { usePrefixClass } from '../hooks/useConfig.mjs';
import '../config-provider/useConfig.mjs';
import '../_chunks/dep-bfb23a5e.mjs';
import '../_chunks/dep-a48de419.mjs';
import '../_chunks/dep-2a7dc5c7.mjs';
import '../_chunks/dep-9311bf66.mjs';
import '../_chunks/dep-4889eb51.mjs';
import '../_chunks/dep-0b4185fe.mjs';
import '../_chunks/dep-3ca5fb38.mjs';
import '../_chunks/dep-7071345f.mjs';
import '../_chunks/dep-d2403b2f.mjs';
import '../_chunks/dep-7922050a.mjs';
import '../_chunks/dep-169ea640.mjs';
import '../_chunks/dep-f6b25712.mjs';
import '../_chunks/dep-59545a4d.mjs';
import '../_chunks/dep-c27b1c14.mjs';
import '../_chunks/dep-7d96367f.mjs';
import '../_chunks/dep-827c4600.mjs';
import '../_chunks/dep-0820e0e2.mjs';
import '../_chunks/dep-caad2e91.mjs';
import '../_chunks/dep-3d4aad09.mjs';
import '../_chunks/dep-8e38f523.mjs';
import '../_chunks/dep-469bf54b.mjs';
import '../_chunks/dep-8ef9fb8e.mjs';
import '../_chunks/dep-e769aafd.mjs';
import '../_chunks/dep-400798c5.mjs';
import '../_chunks/dep-361522ee.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../config-provider/type.mjs';

var TSliderMark = defineComponent({
  name: "TSliderMark",
  props: {
    mark: {
      type: [Object, Array, String, Number]
    },
    point: {
      type: Number
    },
    onClickMarkPoint: {
      type: Function,
      "default": function _default() {}
    }
  },
  setup: function setup(props) {
    var COMPONENT_NAME = usePrefixClass("slider__mark");

    var changeValue = function changeValue(e) {
      var _props$onClickMarkPoi;

      e.stopPropagation();
      props === null || props === void 0 ? void 0 : (_props$onClickMarkPoi = props.onClickMarkPoint) === null || _props$onClickMarkPoi === void 0 ? void 0 : _props$onClickMarkPoi.call(props, props.point);
    };

    return function () {
      return createVNode("div", {
        "class": "".concat(COMPONENT_NAME.value, "-text"),
        "onClick": changeValue
      }, [props.mark]);
    };
  }
});

export { TSliderMark as default };
//# sourceMappingURL=slider-mark.mjs.map
